// Функция получения всех product handles
function getProductHandles() {
    const productBundle = document.querySelector('.rebolt_ProductBundle');
    if (!productBundle) return []; // Если контейнера нет — возвращаем пустой массив

    const links = productBundle.querySelectorAll('a[href^="/products/"]');
    const handles = new Set();

    links.forEach(link => {
        const urlParts = link.getAttribute('href').split('/products/');
        if (urlParts[1]) {
            handles.add(urlParts[1].split('?')[0]); // Убираем query параметры
        }
    });

    return Array.from(handles);
}

async function waitForHandles(attempt = 1, maxAttempts = 50) {
    const handles = getProductHandles();

    if (handles.length > 0) {
        console.log(`Нашёл ${handles.length} handle:`, handles);
        return handles;
    } else if (attempt < maxAttempts) {
        console.warn(`Попытка ${attempt}: контейнер не найден, пробуем ещё раз...`);
        return new Promise(resolve =>
            setTimeout(() => resolve(waitForHandles(attempt + 1, maxAttempts)), 500)
        );
    } else {
        console.error("Не удалось найти handle после нескольких попыток.");
        return [];
    }
}

async function fetchProductIds(handles) {
    try {
        const productIds = [];

        for (const handle of handles) {
            const response = await fetch(`/products/${handle}.js`);
            if (!response.ok) {
                console.error(`Ошибка загрузки данных для ${handle}`);
                continue;
            }

            const productData = await response.json();
            productIds.push(productData.id); // Сохраняем только ID
        }

        return productIds;
    } catch (error) {
        console.error("Ошибка получения данных о товарах:", error);
        return [];
    }
}

async function fetchProductMetafields(productIds) {
    try {
        const promises = productIds.map(productId =>
            fetch('https://bundle-laflore.netlify.app/api/shopify-metafields', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ productId }),
            })
                .then(response => response.json())
                .then(metafieldData => ({ productId, metafields: metafieldData }))
                .catch(error => console.error(`Ошибка для product ID ${productId}:`, error))
        );

        const metafieldResponses = await Promise.all(promises);
        return metafieldResponses;
    } catch (error) {
        console.error('Ошибка получения мета-полей:', error);
        return [];
    }
}
 
async function processProducts() {
    const handles = await waitForHandles();
    if (handles.length === 0) return;

    const productIds = await fetchProductIds(handles);
    console.log('Полученные product IDs:', productIds);

    const productMetafields = await fetchProductMetafields(productIds);
    console.log('Полученные мета-поля для продуктов:', productMetafields);

  const variantMetafields = getHideMetafields(productMetafields);
  console.log(variantMetafields);
  applyVariantRestrictions(variantMetafields); // применяем ограничения


}


function getHideMetafields(productDataArray) {
    console.log(productDataArray);
    console.log("get hide bro");

    const result = {}; // Объект для хранения данных по вариантам

    productDataArray.forEach((productData) => {
        if (productData?.metafields?.variants?.edges) {
            console.log("edges");
            productData.metafields.variants.edges.forEach((variant) => {
                let variantId = variant.node.id.replace("gid://shopify/ProductVariant/", ""); // Убираем префикс
                const metafields = variant.node.metafields.edges;

                // Ищем значения rest_hide и us_hide в мета-полях
                const restHide = metafields.find(
                    (field) => field.node.namespace === "custom" && field.node.key === "rest_hide"
                )?.node.value;

                const usHide = metafields.find(
                    (field) => field.node.namespace === "custom" && field.node.key === "us_hide"
                )?.node.value;

                // Сохраняем найденные значения
                result[variantId] = {
                    rest_hide: restHide || "false", // Если значения нет, по умолчанию "false"
                    us_hide: usHide || "false",
                };
            });
        }
    });

    return result;
}
 


function applyVariantRestrictions(variantHideMap) {
  const userGeo = localStorage.getItem('userGeolocation') || 'rest';
  const allSelectors = document.querySelectorAll('.RB_PC_Selector');

  allSelectors.forEach(select => {
    const originalFirstOption = select.options[0]?.value;
    const options = Array.from(select.options);
    let removedFirstOption = false;

    options.forEach(option => {
      const variantId = option.value;
      const hideData = variantHideMap[variantId];
      if (!hideData) return;

      const restHidden = hideData.rest_hide === "true";
      const usHidden = hideData.us_hide === "true";

      const shouldRemove =
        (userGeo === "us" && usHidden) ||
        (userGeo !== "us" && restHidden) ||
        (usHidden && restHidden);

      if (shouldRemove) {
        if (option.value === originalFirstOption) {
          removedFirstOption = true;
        }
        option.remove();
      }
    });

    // Если удалили первую опцию — выбираем новую первую и инициируем событие
    if (removedFirstOption && select.options.length > 0) {
      select.selectedIndex = 0; // выбираем новый первый элемент
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}



processProducts();
